import { NgModule } from '@angular/core';
import { StpCommonModule } from '../common/common.module';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [],
  imports: [
    HttpClientModule,
    StpCommonModule
  ]
})
export class StpApiClientModule { }
